var map = {
	"./project/capacity-size/desktop.svg": "d232",
	"./project/capacity-size/mobile.svg": "95de",
	"./project/capacity-size/tablet.svg": "b05e",
	"./project/cover/cover-big.png": "44ac",
	"./project/cover/cover-desktop.png": "2d8f",
	"./project/cover/cover-tablet.png": "c4db",
	"./project/cover/cover.png": "5176",
	"./project/map-logo-bak/map-logo-desktop.jpg": "7180",
	"./project/map-logo-bak/map-logo.jpg": "8716",
	"./project/map-logo-desktop.jpg": "90b2",
	"./project/map-logo-svg/desktop.svg": "dd98",
	"./project/map-logo-svg/desktop1.png": "909d",
	"./project/map-logo-svg/mobile.svg": "e27a",
	"./project/map-logo-svg/mobile1.png": "b031",
	"./project/map-logo-svg/tablet.svg": "df02",
	"./project/map-logo-svg/tablet1.png": "98f1",
	"./project/map-logo.jpg": "65af",
	"./project/map-logos/1-microsoft.png": "d4f1",
	"./project/map-logos/10-sap.png": "79a0",
	"./project/map-logos/11-oracle.png": "b718",
	"./project/map-logos/12-alibaba.png": "fe58",
	"./project/map-logos/13-workday.png": "3d19",
	"./project/map-logos/14-servicenow.png": "b224",
	"./project/map-logos/15-dropbox.png": "7fe3",
	"./project/map-logos/2-aws.png": "9442",
	"./project/map-logos/3-hp.png": "639a",
	"./project/map-logos/4-salesforce.png": "50bd",
	"./project/map-logos/5-cisco.png": "5480",
	"./project/map-logos/6-dell.png": "8ac8",
	"./project/map-logos/7-ibm.png": "03a1",
	"./project/map-logos/8-google.png": "1f0c",
	"./project/map-logos/9-adobe.png": "f72e",
	"./project/meta-data-centre-desktop.jpg": "fa47",
	"./project/meta-data-centre.jpg": "b00c",
	"./project/meta-desktop.jpg": "e470",
	"./project/meta.jpg": "b667",
	"./project/nongsa-desktop.jpg": "dee0",
	"./project/nongsa.jpg": "9573",
	"./project/nusajaya-desktop.jpg": "3c5d",
	"./project/nusajaya-tech-park-desktop.jpg": "8d85",
	"./project/nusajaya-tech-park.jpg": "643d",
	"./project/nusajaya.jpg": "10e4",
	"./project/satellite-gifs/meta-desktop.gif": "884f",
	"./project/satellite-gifs/meta.gif": "d70c",
	"./project/satellite-gifs/nongsa-desktop.gif": "4c4d",
	"./project/satellite-gifs/nongsa.gif": "f851",
	"./project/satellite-gifs/nusajaya-desktop.gif": "f9dc",
	"./project/satellite-gifs/nusajaya.gif": "21ab",
	"./project/satellite-images/meta-2-2018-desktop.jpg": "9eaa",
	"./project/satellite-images/meta-2-2018.jpg": "d46e",
	"./project/satellite-images/meta-2-2019-desktop.jpg": "899d",
	"./project/satellite-images/meta-2-2019.jpg": "313c",
	"./project/satellite-images/meta-2-2020-desktop.jpg": "a3f1",
	"./project/satellite-images/meta-2-2020.jpg": "53d4",
	"./project/satellite-images/meta-2015-desktop.jpg": "abd1",
	"./project/satellite-images/meta-2015.jpg": "2cd5",
	"./project/satellite-images/meta-2017-desktop.jpg": "eb66",
	"./project/satellite-images/meta-2017.jpg": "9d46",
	"./project/satellite-images/meta-2020-desktop.jpg": "9e4d",
	"./project/satellite-images/meta-2020.jpg": "d73e",
	"./project/satellite-images/nongsa-2015-desktop.jpg": "8957",
	"./project/satellite-images/nongsa-2015.jpg": "3e3e",
	"./project/satellite-images/nongsa-2019-desktop.jpg": "0b25",
	"./project/satellite-images/nongsa-2019.jpg": "f249",
	"./project/satellite-images/nongsa-2021-desktop.jpg": "f89a",
	"./project/satellite-images/nongsa-2021.jpg": "5478",
	"./project/satellite-images/nusajaya-2015-desktop.jpg": "d2323",
	"./project/satellite-images/nusajaya-2015.jpg": "6f4e",
	"./project/satellite-images/nusajaya-2018-desktop.jpg": "4111",
	"./project/satellite-images/nusajaya-2018.jpg": "9d6a",
	"./project/satellite-images/nusajaya-2021-desktop.jpg": "eb0c",
	"./project/satellite-images/nusajaya-2021.jpg": "7f33",
	"./template/image-background-header-desktop.jpg": "5c5b",
	"./template/image-background-header.jpg": "32e0",
	"./template/sample-image-desktop.png": "3100",
	"./template/sample-image.png": "da96",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8453";